import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../context/useAuth";
import { getAccessToken } from "../utils/cookies";
import { getDefaultRouteForRole } from "./authRedirects";

const GuestRoute = () => {
  const { user } = useAuth();
  const token = getAccessToken();

  if (!token) return <Outlet />;

  return <Navigate to={getDefaultRouteForRole(user?.role)} replace />;
};

export default GuestRoute;
